/*
 * HOG CTA spinner — measure sticky range + colour fade (no positioning).
 * Sticky pin is pure CSS in homepage-sticky-animation.css (all breakpoints).
 *
 * Range: document distance from CTA inner top → next section top (cleared spacer/
 * margin), so sticky holds until next section top meets the pin line.
 * Fade: --hog-cta-fade 0→1 over the second half of that range; reverses on scroll up.
 */
(function () {
  'use strict';

  var REDUCED_MQ = '(prefers-reduced-motion: reduce)';
  var FADE_STEPS = 20;
  var TARGET_SEL = '.hog-cta-spinner--sticky-target';
  var NEXT_SEL = '.hog-image-cards--sticky-next';
  var SPACER_SEL = '.hog-cta-spinner__sticky-spacer';
  var INNER_SEL = '.hog-cta-spinner__inner';

  var rafId = 0;
  var lastStep = -1;
  var stickyRange = 0;
  var target = null;
  var next = null;
  var nextSection = null;
  var spacer = null;
  var inner = null;
  var layout = null;
  var reducedMq = window.matchMedia(REDUCED_MQ);
  var bound = false;

  function scrollY() {
    return window.scrollY || window.pageYOffset || 0;
  }

  function docTop(el) {
    return el.getBoundingClientRect().top + scrollY();
  }

  function setFade(progress) {
    if (!target) return;
    var fade = 0;
    if (progress > 0.5) fade = (progress - 0.5) / 0.5;
    fade = Math.min(1, Math.max(0, fade));

    var step = Math.round(fade * FADE_STEPS);
    if (step === lastStep) return;
    lastStep = step;
    target.style.setProperty('--hog-cta-fade', String(step / FADE_STEPS));
  }

  /**
   * Measure once: how far next section top is below CTA inner top in document flow.
   * Apply as spacer height + matching negative margin (overlay without layout growth).
   */
  function measureStickyRange() {
    if (!spacer || !nextSection || !inner || !layout) return;

    if (reducedMq.matches) {
      stickyRange = 0;
      spacer.style.height = '';
      nextSection.style.marginTop = '';
      layout.style.removeProperty('--hog-cta-sticky-range');
      lastStep = -1;
      setFade(0);
      return;
    }

    // Clear so we measure natural sibling positions (not current spacer/margin).
    spacer.style.height = '0px';
    nextSection.style.marginTop = '0px';

    var range = Math.max(0, Math.round(docTop(nextSection) - docTop(inner)));
    stickyRange = range;

    spacer.style.height = range + 'px';
    nextSection.style.marginTop = range > 0 ? -range + 'px' : '';
    layout.style.setProperty('--hog-cta-sticky-range', range + 'px');

    lastStep = -1;
    updateFade();
  }

  function updateFade() {
    if (reducedMq.matches || !target || !next || !inner) {
      lastStep = -1;
      setFade(0);
      return;
    }

    if (stickyRange <= 0) {
      setFade(0);
      return;
    }

    var pinTop = parseFloat(getComputedStyle(inner).top) || 0;
    var nextTop = next.getBoundingClientRect().top;
    // Prefer nextSection top (includes section chrome) for handoff parity.
    if (nextSection) nextTop = nextSection.getBoundingClientRect().top;
    var progress = 1 - (nextTop - pinTop) / stickyRange;
    setFade(progress);
  }

  function tick() {
    rafId = 0;
    updateFade();
  }

  function requestTick() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(tick);
  }

  function onResize() {
    measureStickyRange();
  }

  function bindListeners() {
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('load', measureStickyRange, { once: true });
    if (typeof reducedMq.addEventListener === 'function') {
      reducedMq.addEventListener('change', measureStickyRange);
    } else if (typeof reducedMq.addListener === 'function') {
      reducedMq.addListener(measureStickyRange);
    }
  }

  function resolveElements() {
    target = document.querySelector(TARGET_SEL);
    next = document.querySelector(NEXT_SEL);
    spacer = document.querySelector(SPACER_SEL);
    inner = document.querySelector(INNER_SEL);
    layout = document.querySelector('.content-for-layout');
    nextSection = next ? next.closest('.shopify-section') || next : null;
    return !!(target && next && nextSection && spacer && inner && layout);
  }

  function init() {
    if (!resolveElements()) return;
    bindListeners();
    measureStickyRange();
  }

  init();

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var hasCta = event.target && event.target.querySelector
        ? event.target.querySelector(TARGET_SEL + ', ' + NEXT_SEL)
        : null;
      if (!hasCta && !document.querySelector(TARGET_SEL)) return;
      lastStep = -1;
      init();
    });
  }
})();
